import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateWorkflowBasicInfo } from '../../../state';
import { useGetWorkflowTriggersQuery } from '../../../../../services/WorkflowService';
import { useWorkflowValidationContext } from '../../shared';

export const WorkflowTriggerField: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);
  const { data: workflowTriggers = [], isLoading: loadingTriggers } = useGetWorkflowTriggersQuery();
  const { errors, showErrors } = useWorkflowValidationContext();

  if (!currentWorkflow) return null;

  const triggerErr = showErrors && errors.trigger;

  return (
    <FormControl size="small" sx={{ minWidth: 250 }} error={!!triggerErr}>
      <InputLabel>Trigger</InputLabel>
      <Select
        value={currentWorkflow.trigger}
        label="Trigger"
        onChange={(e) => dispatch(updateWorkflowBasicInfo({ trigger: e.target.value }))}
        disabled={loadingTriggers}
      >
        {workflowTriggers.map((t) => (
          <MenuItem key={t.value} value={t.value}>
            {t.name}
          </MenuItem>
        ))}
      </Select>
      {triggerErr && <FormHelperText>{triggerErr}</FormHelperText>}
    </FormControl>
  );
};

export default WorkflowTriggerField;
